module.exports = __webpack_public_path__ + "media/avengers.4dd6eb98.webm";